import { pdtPush } from '@growth/pdt-push';
import adobeAnalytics from '@growth/analytics-plugin-adobe';
import { isUserTokenPresent, getUuidFromCookie } from '@growth/auth-helpers';
import WebAnalytics from '@growth/web-analytics';

var sendPdtEvent = function sendPdtEvent(_ref) {
  var eventName = _ref.eventName,
    eventType = _ref.eventType,
    contentId = _ref.contentId,
    contentCategoryName = _ref.contentCategoryName,
    pageName = _ref.pageName;
  pdtPush(eventName, {
    event_detail: {
      event_type: eventType,
      pageName: pageName,
      components: [{
        content_details: [{
          content_id: contentId,
          content_category_name: contentCategoryName || ''
        }]
      }]
    }
  });
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var adobeInstance = new WebAnalytics();
var initOmnitureAnalytics = function initOmnitureAnalytics(_ref) {
  var _window$adobeDataLaye, _window$adobeDataLaye2;
  var lobName = _ref.lobName,
    debug = _ref.debug,
    flavour = _ref.flavour;
  var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null || _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
  var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null || _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
  adobeInstance.initialize({
    plugin: adobeAnalytics({
      page: {
        pageInfo: _extends({
          lob: lobName,
          pageType: 'landing',
          section: 'landing',
          platform: flavour
        }, pageInfo)
      },
      account: {
        accountInfo: _extends({
          loginStatus: "" + (isUserTokenPresent() ? 'logged-in' : 'guest'),
          website: 'goibibo',
          custID: getUuidFromCookie(),
          isAppInstalled: 'unknown'
        }, accountInfo)
      }
    }, debug || false),
    debug: debug || false
  });
  return adobeInstance;
};

export { _extends as _, initOmnitureAnalytics as i, sendPdtEvent as s };
